import { bigCommerceFetch } from "."
import { api, postDBEntry } from "../../../../api"
import { BKDFFromBigCommerceLineItems, bigCommerceToBKDFCart } from "./mapper"
import { createCartMutation } from "./mutations/cart"
import { getStoreProductsQuery } from "./queries/product"

const getBigCommerceProductsWithCheckoutInformation = async (cartId: string) => {
    const cartRes = await api("dummyCartEndpoint/" + cartId, {})

    const cart = cartRes.data?.data?.cart
    if (!cart) {
        return {
            productsByIdList: null,
            cart: null,
            checkoutUrl: null,
        }
    }
    console.log("cart:", cart)
    const checkoutUrl = cartRes.data.data.embeddedCheckoutURL
    const lines = BKDFFromBigCommerceLineItems(cart.lineItems)
    console.log(lines, "Lines")
    const productIds = lines.map(({ merchandiseId }) => parseInt(merchandiseId))
    const bigCommerceProductListRes = await bigCommerceFetch<BigCommerceProductsOperation>({
        query: getStoreProductsQuery,
        variables: {
            entityIds: productIds,
        },
        cache: "no-store",
    })
    const bigCommerceProductList = bigCommerceProductListRes.body.data.site.products.edges.map(
        (product) => product.node
    )
    const createProductList = (idList: number[], products: BigCommerceProduct[]) => {
        return idList.map((productId) => {
            const productData = products.find(({ entityId }) => entityId == productId)!
            return {
                productId,
                productData,
            }
        })
    }
    const bigCommerceProducts = createProductList(productIds, bigCommerceProductList)
    return {
        productsByIdList: bigCommerceProducts,
        cart,
        checkoutUrl,
    }
}

export async function createCart(
    lines: { merchandiseId: string; quantity: number; productId?: string }[]
): Promise<BKDFCart | null> {
    let bigCommerceCart: BigCommerceCart

    const res = await bigCommerceFetch<BigCommerceCreateCartOperation>({
        query: createCartMutation,
        variables: {
            createCartInput: {
                lineItems: lines.map(({ merchandiseId, quantity, productId }) => ({
                    productEntityId: parseInt(productId!, 10),
                    variantEntityId: parseInt(merchandiseId, 10),
                    quantity,
                })),
            },
        },
        cache: "no-store",
    })
    bigCommerceCart = res.body.data.cart.createCart.cart
    const { cart, productsByIdList, checkoutUrl } = await getBigCommerceProductsWithCheckoutInformation(
        bigCommerceCart.entityId
    )
    console.log("Cart:", cart, "Products:", productsByIdList, "Checkout:", checkoutUrl)
    if (!cart || !productsByIdList) return null
    return bigCommerceToBKDFCart(cart, productsByIdList, checkoutUrl)
}

export async function addCartItem(
    cartId: string,
    lines: { merchandiseId: string; quantity: number; productId?: string }[]
): Promise<BKDFCart | null> {
    await postDBEntry("dummyCartEndpoint", {
        operation: "add",
        cartId,
        lineItems: lines.map(({ merchandiseId, quantity, productId }) => ({
            product_id: productId,
            variant_id: merchandiseId,
            quantity,
        })),
    })

    const { cart, productsByIdList, checkoutUrl } = await getBigCommerceProductsWithCheckoutInformation(cartId)
    if (!cart || !productsByIdList) return null
    return bigCommerceToBKDFCart(cart, productsByIdList, checkoutUrl)
}

export async function updateCartItem(
    cartId: string,
    line: { merchandiseId: string; productId: string; quantity: number; entityId: string }
): Promise<BKDFCart | null> {
    await postDBEntry("dummyCartEndpoint", {
        operation: "update",
        lineItem: {
            product_id: line.productId,
            variant_id: line.merchandiseId,
            quantity: line.quantity,
        },
        cartId,
        entityId: line.entityId,
    })

    const { cart, productsByIdList, checkoutUrl } = await getBigCommerceProductsWithCheckoutInformation(cartId)
    if (!cart || !productsByIdList) return null
    return bigCommerceToBKDFCart(cart, productsByIdList, checkoutUrl)
}

export async function deleteCartItem(cartId: string, lineId: string): Promise<BKDFCart | null> {
    await postDBEntry("dummyCartEndpoint", {
        operation: "delete",
        cartId,
        entityId: lineId,
    })

    const { cart, productsByIdList, checkoutUrl } = await getBigCommerceProductsWithCheckoutInformation(cartId)
    if (!cart || !productsByIdList) return null
    return bigCommerceToBKDFCart(cart, productsByIdList, checkoutUrl)
}

export async function getCart(cartId: string): Promise<BKDFCart | null> {
    const { cart, productsByIdList, checkoutUrl } = await getBigCommerceProductsWithCheckoutInformation(cartId)
    if (!cart || !productsByIdList) return null
    return bigCommerceToBKDFCart(cart, productsByIdList, checkoutUrl)
}
